import { render, staticRenderFns } from "./goodsSearch.vue?vue&type=template&id=2e25ceaa&scoped=true&"
import script from "./goodsSearch.vue?vue&type=script&lang=js&"
export * from "./goodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./goodsSearch.vue?vue&type=style&index=0&id=2e25ceaa&lang=scss&scoped=true&"
import style1 from "./goodsSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25ceaa",
  null
  
)

export default component.exports